import React from 'react'

const IconMap = props => (
  <svg
    className="icon"
    width={32}
    height={33}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5 14.895c0 3.105-1.5 5.105-3 7.409-1.5 2.304-3.872 5.196-3.872 5.196s-2.385-2.892-4.006-5.196C10 20 8.5 18 8.5 15c0-4 2.524-7.5 7-7.5s7 3.5 7 7.395Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconMap
